import './Careers.scss'
import type { ReactNode } from 'react'
import { LocalizedLink } from '#src/components/LocalizedLink.js'
import type { CareersPageData } from '#src/pages/careers/careersPageData.js'

interface Props {
  data: CareersPageData
}

export default function CareersPage(props: Props): ReactNode {
  const { title, slug, positions } = props.data

  return (
    <section className="careers">
      <div className="careers__inner-container">
        <h1 className="careers__heading">{title}</h1>
        <div className="careers__positions-list">
          {positions.map(position => (
            <LocalizedLink
              href={`/${slug}/${position.slug}`}
              key={position.slug}
              className="careers__position"
            >
              {position.title}
            </LocalizedLink>
          ))}
        </div>
      </div>
    </section>
  )
}
